import {useController, UseControllerProps, UseControllerReturn, useFormContext} from 'react-hook-form';

// replace null or undefined values by empty string to avoid controlled/uncontrolled input warning
const defaultFormat = (value: any) => (value == null ? '' : value);
// parse empty string into null as it's more suitable for a majority of backends
const defaultParse = (value: string) => (value === '' ? null : value);

export type InputProps = {
  source: string;
  label?: string;
  type?: string;
  helperText?: string;
  format?: (any) => any; //from form's data to display
  parse?: (any) => any; //from displayed data to form's data
} & Omit<UseControllerProps, 'name'>;

export const useInput: (props: InputProps) => UseControllerReturn = (props: InputProps) => {
  const {parse, format} = props;  
  const controllerResults = useController({...props, name: props.source});

  // if (!parse && !format) return controllerResults;

  const field = {
    ...controllerResults.field,
    value: format
      ? format(controllerResults.field.value)
      : defaultFormat(controllerResults.field.value),
    onChange: (...event: any[]) => {
      const eventOrValue = (
        props.type === 'checkbox' && event[0]?.target?.value === 'on'
          ? event[0].target.checked
          : event[0]?.target?.value ?? event[0]
      ) as any;
      controllerResults.field.onChange(parse ? parse(eventOrValue) : defaultParse(eventOrValue));
    },
  };

  return {
    ...controllerResults,
    field,
  };
};
